import React from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { PageHeader } from '../components/common'
import SessionSchedulingCalendar from '../components/sessions/SessionSchedulingCalendar'

const QuestRescheduleSession = () => {
  const history = useHistory()
  const location = useLocation()
  const { questId } = useParams()
  const scheduledSession = location.state?.scheduledSession

  const renderHelmet = () => (
    <Helmet>
      <title>{'Reschedule Quest Session | Abroad'}</title>
      <meta name='title' content={'Reschedule Quest Session | Abroad'}></meta>
      <meta
        property='og:title'
        content={'Reschedule Quest Session | Abroad'}></meta>
      <meta
        property='twitter:title'
        content={'Reschedule Quest Session | Abroad'}></meta>
      <link
        rel='canonical'
        href={`${process.env.REACT_APP_DOMAIN}/your-experiences/${questId}/reschedule-session`}></link>
      <meta
        property='og:url'
        content={`${process.env.REACT_APP_DOMAIN}/your-experiences/${questId}/reschedule-session`}></meta>
      <meta
        property='twitter:url'
        content={`${process.env.REACT_APP_DOMAIN}/your-experiences/${questId}/reschedule-session`}></meta>
    </Helmet>
  )

  const handleScheduleSuccess = (event) => {
    // Navigate back to quest session list page after successful reschedule
    history.push(`/your-experiences/${questId}/session-list`)
  }

  return (
    <>
      {renderHelmet()}
      <PageHeader
        title='Sessions'
        version='small'
        backArrowAction={() =>
          history.push(`/your-experiences/${questId}/session-list`)
        }
        showBackArrow={true}
      />
      <SessionSchedulingCalendar
        schedulingType='reschedule'
        scheduledSession={
          scheduledSession
            ? {
                ...scheduledSession,
                questId,
                isFromQuest: true, // Flag to indicate this is from quest route
              }
            : null
        }
        onScheduleSuccess={handleScheduleSuccess}
      />
    </>
  )
}

export default QuestRescheduleSession
